"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientLoadingPanelManager = void 0;
var tslib_1 = require("tslib");
var manager_1 = require("../../base/loading-panel/manager");
var panel_1 = require("./panel");
var status_bar_panel_1 = require("./status-bar-panel");
var ClientLoadingPanelManager = (function (_super) {
    tslib_1.__extends(ClientLoadingPanelManager, _super);
    function ClientLoadingPanelManager(canvas) {
        var _this = _super.call(this) || this;
        _this.loadingPanel = new panel_1.ClientLoadingPanel(canvas);
        _this.statusBarLoadingPanel = new status_bar_panel_1.ClientStatusBarLoadingPanel();
        return _this;
    }
    return ClientLoadingPanelManager;
}(manager_1.LoadingPanelManagerBase));
exports.ClientLoadingPanelManager = ClientLoadingPanelManager;
